import { Component } from '@angular/core';

@Component({
  selector: 'ntt-dropdown-menu-divider',
  templateUrl: './dropdown-menu-divider.html',
  styleUrl: './dropdown-menu-divider.scss',
})
export class NttDropdownMenuDivider {}
